(function () {
    'use strict';

    angular.module("imApp").factory("batchDelPurchLineService", ['$ihttp', function ($ihttp) {
        let service = {
            getInfo: function (parms) {
                return $ihttp.post({
                    method: 287,
                    parameters: parms || {}
                });
            },
            deleteItem: function (info) {
                return $ihttp.post({
                    method: 290,
                    parameters: info
                });
            },
            rollbackItem: function (info) {
                return $ihttp.post({
                    method: 1720,
                    parameters: info
                });
            }
        };

        return service;
    }]);
})();
